module.exports = __webpack_public_path__ + "img/img39.f565f22f.jpg";